import { initComponent } from './core/init-component.js'
import Mailcheck from 'mailcheck'

const extractVisibleText = el => {  
  const clone = el.cloneNode(true)
  clone.querySelectorAll('[aria-hidden="true"]').forEach(hidden => hidden.remove())
  return clone.innerText.trim()
}

initComponent('.js-ff-newsletter', section => {
  const form = section.querySelector('.js-ff-newsletter-form')
  const emailInput = form?.querySelector('[data-ff-email-input]')
  const emailSuggest = form?.querySelector('[data-ff-email-suggestion]')
  const success = section.querySelector('.ff-newsletter__success-message')

  if (!form) return  

  form.addEventListener('submit', async e => {    
    emailSuggest?.setAttribute('hidden', true)
    let mailcheckHasSuggestion = false

    Mailcheck.run({
      email: emailInput.value,  
      suggested: suggestion => {
        mailcheckHasSuggestion = true
        emailSuggest.innerHTML = `Did you mean <strong>${suggestion.full}</strong>?`
        emailSuggest.removeAttribute('hidden')
      },
      empty: () => {}
    })

    if (mailcheckHasSuggestion) {
      e.preventDefault()
      return
    }

    if (!form.checkValidity()) {
      form.reportValidity()
      e.preventDefault()
      return
    }
    e.preventDefault()

    section.classList.add('ff-newsletter--loading')

    const visibleProfiles = Array.from(
      document.querySelectorAll('.js-ff-quiz-results-profile .js-result-profile')
    ).filter(el => {
      const style = window.getComputedStyle(el)
      return style.display !== 'none' && style.visibility !== 'hidden' && !el.classList.contains('hidden')
    })

    const profile = visibleProfiles.map(extractVisibleText).join(' ').replace(/\s+/g, ' ').trim()    

    const endpoint = form.getAttribute('action')
    const email = form.querySelector('input[name="email"]')?.value
    const region_id = form.querySelector('input[name="region_id"]')?.value
    const quiz_context = form.querySelector('input[name="quiz_context"]')?.value
    const quiz_url = form.querySelector('input[name="quiz_url"]')?.value
    const recommended_products = JSON.parse(form.querySelector('input[name="recommended_products"]')?.value || '[]')
    
    const subscribeCheckboxes = form.querySelectorAll('[data-subscribe]')    
    let marketing_optin = null
    if (subscribeCheckboxes.length > 0) {      
      const anySubscribed = Array.from(subscribeCheckboxes).some(cb => cb.checked)
      marketing_optin = anySubscribed ? 'EXPLICITLY_OPTEDIN' : 'NOT_SPECIFIED'
    }    

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          quiz_context,
          profile,
          recommended_products,
          region_id,
          marketing_optin,
          quiz_url
        })
      })

      const data = await res.json()      

      if (!res.ok || !data.ok) {
        console.error('Ometria error:', data)
        section.classList.remove('ff-newsletter--loading')
      } else {        
        section.classList.remove('ff-newsletter--loading')
        section.classList.add('ff-newsletter--success')
        document.activeElement.blur()
        document.body.focus()
        
        setTimeout(() => {          
          success.focus({ preventScroll: true })          
        }, 500)
        
      }
    } catch (err) {
      console.error('Ometria exception:', err)
      section.classList.remove('ff-newsletter--loading')
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'ff_email_submit'
    });
  })

  return {
    unload() {
      form.removeEventListener('submit')
    }
  }
})